import React from 'react';
import { CallbackComponent } from 'redux-oidc';
import { connect } from 'react-redux';
import toastr from 'toastr';
import { userManager } from '../utils/user-manager';

class CallbackPage extends React.Component {
    successCallback(user) {
        console.log(user);
        console.log(user.state);
        window.location.href = user.state.returnTo;
    }

    errorCallback(error){
        console.log(error);
        toastr.error(error.message, 'We were unable to log you in', { timeOut: 0, extendedTimeOut: 0 });
        window.location.href = '/';
    }

    render() {
        return (
            <CallbackComponent userManager={userManager} successCallback={this.successCallback.bind(this)}  errorCallback={this.errorCallback.bind(this)}>
                <div>
                Redirecting...
                </div>
            </CallbackComponent>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(CallbackPage);
